import {FC, ReactElement, useMemo, useState} from 'react';
import {
  LogoWrapper,
  SidebarWrapper,
  MenuWrapper,
  MenuItemWrapper,
  CollapsedSidebarWrapper,
} from './Sidebar.styles';
import {ReactComponent as Logo} from '@assets/logo.svg';
import {
  BusinessMetrics,
  ExamMode,
  Group,
  HardwareSecurityModule,
  ChevronLeft,
  ChevronRight,
} from '@carbon/icons-react';
import Text from '@atoms/Text';
import {ERoutes} from '@constants/routes';
import {useLocation, useNavigate} from 'react-router';
import {useSelector} from "react-redux";
import {RootState} from "@store";
import {EUserRoles} from "@constants/usersRoles";

export interface menuItemProps {
  text: string;
  icon: ReactElement;
  route: ERoutes;
}

const baseMenuItems: menuItemProps[] = [
  {
    text: 'Системы и покрытие',
    icon: <BusinessMetrics size={16} />,
    route: ERoutes.SYSTEMS,
  },
];

const adminMenuItems: menuItemProps[] = [
  {
    text: 'Системы и покрытие',
    icon: <BusinessMetrics size={16} />,
    route: ERoutes.SYSTEMS,
  },
  {text: 'Виды тестов', icon: <ExamMode size={16} />, route: ERoutes.TESTS},
  {text: 'Пользователи', icon: <Group size={16} />, route: ERoutes.USERS},
  {
    text: 'Лицензии',
    icon: <HardwareSecurityModule size={16} />,
    route: ERoutes.LICENSE,
  },
];

const Sidebar: FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const systemRole = useSelector((state: RootState) => state.profile.profile?.role_id);

  const menuItems = useMemo(() => {
    if (!systemRole || systemRole === EUserRoles.BASE_USER) {
      return baseMenuItems;
    } else {
      return adminMenuItems;
    }
  }, [systemRole]);

  const onClickCollapsedSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const _renderMenuItem = (menuItem: menuItemProps) => {
    return (
      <MenuItemWrapper
        key={`sidebar-menu-item-${menuItem.route}`}
        active={pathname == menuItem.route}
        onClick={() => navigate(menuItem.route)}>
        {menuItem.icon}
        {!sidebarCollapsed && <Text text={menuItem.text} type="bodyM" />}
      </MenuItemWrapper>
    );
  };

  return (
    <SidebarWrapper collapsed={sidebarCollapsed}>
      <LogoWrapper collapsed={sidebarCollapsed}>
        {!sidebarCollapsed && <Logo />}
        <CollapsedSidebarWrapper onClick={onClickCollapsedSidebar}>
          {!sidebarCollapsed && <ChevronLeft size={16} />}
          {sidebarCollapsed && <ChevronRight size={16} />}
        </CollapsedSidebarWrapper>
      </LogoWrapper>
      <MenuWrapper>
        {menuItems.map(menuItem => {
          return _renderMenuItem(menuItem);
        })}
      </MenuWrapper>
    </SidebarWrapper>
  );
};

export default Sidebar;
